export default {
  validation: {
    requiredAtLeaseOneCheckbox: 'You must check at lease one checkbox.',
    requiredBothCheckboxes: 'You must accept both fields.'
  }
}
